import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductGoals = createAction('[StaticData] Load ProductGoals');

export const loadProductGoalsSuccess = createAction(
  '[StaticData] Load ProductGoals Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductGoalsFailure = createAction('[StaticData] Load ProductGoals Failure', props<{ error: any }>());
